module.exports = __webpack_public_path__ + "static/media/F-1.d31a4b8f.webp";